import { render, staticRenderFns } from "./ManageCustomer.vue?vue&type=template&id=4ff9b75f"
import script from "./ManageCustomer.vue?vue&type=script&lang=js"
export * from "./ManageCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports